<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mt-2 mb-2">
      <div class="d-flex align-items-center">
        <span class="mr-2">{{ $t("paiement.filtrerParStatut") }}</span>
        <a-switch
          :checked="showDeletedClasses"
          :checked-children="$t('paiement.actives') || 'Actives'"
          :un-checked-children="$t('paiement.toutes') || 'Toutes'"
          @change="(v) => $emit('toggle-deleted', v)"
        />
      </div>
    </div>

    <a-input-search
      class="mb-3"
      :placeholder="$t('scolarite.charcherParClasse')"
      @keyup="(e) => $emit('search', e.target.value)"
    />

    <a-empty
      v-if="!items.length"
      :description="$t('scolarite.aucuneClasseTrouvee')"
      class="mt-4"
    />

    <div v-else class="affectation-list list-group">
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center affectation-row"
        @click="$emit('select', item.id)"
      >
        <div class="d-flex align-items-center">
          <a-icon
            type="swap"
            class="mr-3 affectation-icon"
            :class="{ 'text-danger': item.status !== 'active' }"
          />
          <div class="text-left">
            <div class="affectation-level">{{ item.levelLabel }}</div>
            <div class="affectation-name text-muted">
              {{ item.name }}
              <a-tag
                v-if="item.status !== 'active'"
                color="red"
                class="ml-2"
              >
                {{ $t("command.inactive") }}
              </a-tag>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <a-tag color="blue" class="mr-2 mb-0">
            {{ item.studentCount }}
            {{ $t("inscriptionStats.eleves") }}
          </a-tag>
          <a-tag color="orange" class="mr-2 mb-0">
            {{ $t("etablissement.niveauAffectation") }}
          </a-tag>
          <a-icon type="right" class="text-muted" />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "AffectationList",
  props: {
    cache: { type: Object, default: () => ({}) },
    levelLabels: { type: Object, default: () => ({}) },
    showDeletedClasses: { type: Boolean, default: false },
    studentCounts: { type: Object, default: () => ({}) },
  },
  computed: {
    items() {
      const rows = [];
      Object.keys(this.cache || {}).forEach((levelKey) => {
        const list = this.cache[levelKey] || [];
        list.forEach((classroom) => {
          if (!this.showDeletedClasses && classroom.status !== "active") {
            return;
          }
          const levelLabel =
            levelKey === "undefined"
              ? this.$t("scolarite.other")
              : this.levelLabels[levelKey] || levelKey;
          const id = classroom._id;
          rows.push({
            id,
            name: classroom.name,
            status: classroom.status,
            levelKey,
            levelLabel,
            studentCount:
              classroom.studentCount != null
                ? classroom.studentCount
                : this.studentCounts[String(id)] || 0,
            sortLevel:
              levelKey === "undefined"
                ? Number.POSITIVE_INFINITY
                : Number(levelKey),
          });
        });
      });
      return rows.sort((a, b) => a.sortLevel - b.sortLevel);
    },
  },
};
</script>

<style scoped>
.affectation-row {
  border-left: 3px solid #fa8c16;
  transition: background-color 0.15s ease;
}
.affectation-row:hover {
  background-color: #fff7e6;
}
.affectation-icon {
  font-size: 18px;
  color: #fa8c16;
}
.affectation-level {
  font-weight: 600;
  font-size: 15px;
  line-height: 1.3;
}
.affectation-name {
  font-size: 13px;
  line-height: 1.3;
}
</style>
